<template>
  <!--
    WHAT — Worklist detail tab "Details". Configures a Patient Worklist's
      top-level scalar fields: free-text description, the metric it is linked to
      (metric_id, chosen from context.metrics), and the active flag.

    CONTRACT — reads record.description / record.metric_id / record.is_active.
      Emits patch({ description, metric_id, is_active }) on every input/change.
      Does NOT touch studio_config or column_config (those are the Data Source
      and Columns tabs). metric_id may be null ("None").

    NOTES — hydrating guard: local state is seeded from record in data(), and
      emit() returns early until $nextTick(mounted) clears `hydrating`, so
      mounting never fires a spurious patch. Plain inputs, no wrapped v1 panel.
      Not selfChrome — ArtifactDetail wraps this body in the standard titled card.
  -->
  <!-- Worklist "Details" — description, linked metric, active. -->
  <div class="grid grid-cols-3 gap-3">
    <div>
      <label class="block text-[10px] font-semibold uppercase tracking-wider text-gray-400 mb-1">Description</label>
      <input v-model="description" class="w-full text-xs px-2 py-1.5 border border-gray-200 rounded-lg focus:outline-none focus:border-blue-400" @input="emit" />
    </div>
    <div>
      <label class="block text-[10px] font-semibold uppercase tracking-wider text-gray-400 mb-1">Linked Metric</label>
      <select v-model="metricId" class="w-full text-xs px-2 py-1.5 border border-gray-200 rounded-lg focus:outline-none focus:border-blue-400" @change="emit">
        <option :value="null">None</option>
        <option v-for="m in metrics" :key="m.id" :value="m.id">{{ m.name }} ({{ m.id }})</option>
      </select>
    </div>
    <div class="flex items-end">
      <label class="flex items-center gap-2 text-xs text-gray-600">
        <input v-model="isActive" type="checkbox" class="rounded" @change="emit" /> Active
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WorklistMetaSection',
  props: {
    record: { type: Object, required: true },
    artifact: { type: Object, required: true },
    context: { type: Object, default: () => ({}) },
  },
  emits: ['patch'],
  data() {
    return {
      description: this.record.description || '',
      metricId: this.record.metric_id ?? null,
      isActive: this.record.is_active !== false,
      hydrating: true,
    };
  },
  computed: {
    metrics() { return this.context.metrics || []; },
  },
  mounted() { this.$nextTick(() => { this.hydrating = false; }); },
  methods: {
    emit() {
      if (this.hydrating) return;
      this.$emit('patch', { description: this.description, metric_id: this.metricId, is_active: this.isActive });
    },
  },
};
</script>
